import * as React from "react";
import { DropTarget, DropTargetCollector, ConnectDropTarget, DropTargetSpec } from "react-dnd";
import styled from "styled-components";

export type Position = "before" | "after";

export type DropHandler = (source: { feature: string }, target: { feature: string; position: Position }) => void;

export interface Props {
  feature: string;
  position: Position;
  connectDropTarget?: ConnectDropTarget;
  isOver?: boolean;
  onDrop: DropHandler;
}

class CompanyValuesDropTarget extends React.PureComponent<Props> {
  public render() {
    const { connectDropTarget, position, isOver } = this.props;
    const Overlay = position === "before" ? TopOverlay : BottomOverlay;
    return connectDropTarget!(
      <div>
        <Overlay>{isOver && <Separator data-position={position} />}</Overlay>
      </div>
    );
  }
}

const dropTarget: DropTargetSpec<Props> = {
  drop({ feature, position, onDrop }, monitor) {
    const source = monitor!.getItem() as any;
    onDrop({ feature: source.feature }, { feature, position });
  },
};

const collect: DropTargetCollector = (connect, monitor) => {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  };
};

const TopOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50%;
`;

const BottomOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
`;

const Separator = styled.div`
  position: absolute;
  width: 100%;
  height: 2px;
  left: 0;
  z-index: 1;
  background-color: red;
  &[data-position="before"] {
    top: -4px;
  }
  &[data-position="after"] {
    bottom: -4px;
  }
`;

export default DropTarget("company_values/sorter", dropTarget, collect)(CompanyValuesDropTarget);



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/CompanyValuesDropTarget.tsx